package pwgs.ui.scenes.customentityeditorscene

import pwgs.ui.scenes.custompropertieseditorscene.ECustomFieldType
import visage.ds.forms.FieldModel
import visage.ds.forms.MetaFieldModel
import visage.ds.forms.SelectOption


class CustomEntityEditorControllerFe(props: CustomEntityEditorSceneProps, scene: MCustomEntityEditorScene) : ACustomEntityEditorControllerFe(props, scene) {

    override fun createInitialModel() : CustomEntityEditorSceneModel {
        return CustomEntityEditorSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }

    fun onEditFieldButtonClicked(field: CustomEntityFieldModel) {
        model.editorDialogModel = CustomEntityFieldEditorDialogModel(
            field.fieldName,
            field.fieldType
        )
        model.editorDialogModel!!.otherFieldModel.value = if (field.fieldType == ECustomFieldType.Bool) "" else field.fieldValue
        model.editorDialogModel!!.boolFieldModel.value = if (field.fieldType != ECustomFieldType.Bool) "" else field.fieldValue
        render(model)
    }

    fun onCancelEditFieldButtonClicked() {
        model.editorDialogModel = null
        render(model)
    }

    fun onSubmitNewFieldValueButtonClicked() {
        model.editorDialogModel!!.isLoading = true
        render(model)

        call_saveField()
    }


}

